export const DISABLED_STATUS = ["TERMINATED", "SUSPENDED"];
export const CHANGE_ACCOUNT_SUBSCRIPTION = "change_account_subscription";
export const EXTEND_ACCOUNT_TRAIL_PERIOD = "EXTEND_ACCOUNT_TRAIL_PERIOD";
export const EXTEND_ACCOUNT_INVITATION_LIMIT = "EXTEND_ACCOUNT_INVITATION_LIMIT";
export const CREATE_NEW_USER  = "CREATE_NEW_USER";
export const UPLOAD_SSO_CONFIGURATION  = "upload_sso_configuration";
export const RESEND_USER_INVITATION = "resend_invitation";
export const DELETE_USER_INVITATION = "delete_invitation";
export const PAPERFLITE_ERROR = "PAPERFLITE_ERROR";
export const SIGNIN_AS_USER = "sign_in_as_user";
export const UPDATE_USER = "update_user";
export const UPDATE_ACCOUNT = "update_account";
export const CREATE_USER = "create_user"; 
export const ACTIVATED_USER = "activated_user";
export const ACCOUNT_SETTINGS_CHANGE = "account_settings_change";  
export const RESET_PASSWORD = "reset_password";
export const REQUESTED_USER = "request_reset_password";
export const GENERATED_FOR_USER = "generated_password_link";
export const EXTEND_TRIAL = "trail_extended";
export const EXTEND_INVITATION_LIMIT = "invitation_limit_extended";

//fetch data sources
export const FETCHING_DATA_SOURCES_REQUEST = "FETCHING_DATA_SOURCES_REQUEST";
export const FETCHING_DATA_SOURCES_SUCCEEDED = "FETCHING_DATA_SOURCES_SUCCEEDED";
export const FETCHING_DATA_SOURCES_FAILED = "FETCHING_DATA_SOURCES_FAILED";

//fetch data source children
export const FETCHING_DATA_SOURCE_CHILDREN_REQUEST = "FETCHING_DATA_SOURCE_CHILDREN_REQUEST";
export const FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED = "FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED";
export const FETCHING_DATA_SOURCE_CHILDREN_FAILED = "FETCHING_DATA_SOURCE_CHILDREN_FAILED";



